import { NAVIGATION_TO_LANDING_PAGE } from '../../actions/page';
import {
  RECEIVE_ITEM_LIMIT,
  RECEIVE_QTY_PER_ITEM_LIMIT,
  TOGGLE_MAX_ITEMS_REACHED,
} from '../../actions/restrictions';

export const initialState = {
  maxItemsReached: false,
  itemLimit: Infinity,
  qtyPerItemLimit: Infinity,
};

export default (
  state = initialState,
  { type, data: { itemLimit, qtyPerItemLimit, maxItemsReached } = {} } = {},
) => {
  switch (type) {
    case RECEIVE_ITEM_LIMIT:
      return {
        ...state,
        itemLimit,
      };

    case RECEIVE_QTY_PER_ITEM_LIMIT:
      return {
        ...state,
        qtyPerItemLimit,
      };

    case TOGGLE_MAX_ITEMS_REACHED:
      return {
        ...state,
        maxItemsReached,
      };

    case NAVIGATION_TO_LANDING_PAGE:
      return {
        ...state,
        maxItemsReached: false,
      };

    default:
      return state;
  }
};
